import { atom, selector } from 'recoil'

import {
  MAX_SEGMENTATION_GROUPS,
  type ModalAddSegmentState,
} from 'Pages/RecipientsList/model'

export const modalAddSegmentState = atom<ModalAddSegmentState>({
  key: 'recipientsList_modalAddSegmentState',
  default: {
    show: false,
    name: null,
    nameConflict: false,
    maxRecipientsInGroup: null,
    distMode: 'Random',
    recipientsCount: 0,
    //
    searchCrit: {
      contact: { value: '', dirty: false },
      status: { value: [], dirty: false },
      criteria: {
        value: [],
        dirty: false,
      },
    },
  },
})

export const modalAddSegmentGroupsCountState = selector<number | undefined>({
  key: 'recipientsList_modalAddSegmentGroupsCountState',
  get: ({ get }) => {
    const { maxRecipientsInGroup, recipientsCount } = get(modalAddSegmentState)

    return maxRecipientsInGroup !== null && maxRecipientsInGroup > 0
      ? Math.ceil(recipientsCount / maxRecipientsInGroup)
      : undefined
  },
})

export const modalAddSegmentMaxGroupsCountExceededState = selector<boolean>({
  key: 'recipientsList_modalAddSegmentMaxGroupsCountExceededState',
  get: ({ get }) => {
    const groupsCount = get(modalAddSegmentGroupsCountState)

    return groupsCount !== undefined && groupsCount > MAX_SEGMENTATION_GROUPS
  },
})

export const modalAddSegmentCanAddState = selector<boolean>({
  key: 'recipientsList_modalAddSegmentCanAddState',
  get: ({ get }) => {
    const { name, maxRecipientsInGroup, recipientsCount } =
      get(modalAddSegmentState)

    const groupsCountExceeded = get(modalAddSegmentMaxGroupsCountExceededState)

    return (
      name != null &&
      name.length > 0 &&
      maxRecipientsInGroup !== null &&
      maxRecipientsInGroup > 0 &&
      recipientsCount > 0 &&
      !groupsCountExceeded
    )
  },
})
